import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, InputGroup, Modal } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Cookie from 'universal-cookie';


function IniciarSesion(props) {
    const location = useLocation();
    const [mensaje, setMensaje] = useState();
    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);
    const [objFormulario, setObjFormulario] = useState({
        correo: "",
        password_cliente: "",
        carrito: location.pathname === '/inicioSesion' ? false : true
    });

    const handleClose = () => setShow(false);
    const navigate = useNavigate();

    const changeFormulario = (e) => {
        let { name, value } = e.target;
        setObjFormulario({
            ...objFormulario,
            [name]: value
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            try {
                let cookies = new Cookie();
                cookies.remove('textoBuscar');
                if (location.pathname === '/inicioSesion') {
                    const cookies = new Cookie();
                    const accessToken = cookies.get('accesToken');
                    const url = process.env.REACT_APP_SERVER + '/api/v1/customers/login';
                    const { data } = await axios.post(url, objFormulario, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    cookies.set('accesToken', data.accesToken, { path: '/' });
                    cookies.set('user', data.result[0], { path: '/' })
                    setMensaje(data["message"]);
                    setShow(true);
                    navigate('/catalogo');
                } else {
                    const cookies = new Cookie();
                    const accessToken = cookies.get('accesToken');
                    const url = process.env.REACT_APP_SERVER + '/api/v1/customers/login';
                    const { data } = await axios.post(url, objFormulario, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    cookies.set('accesToken', data.accesToken, { path: '/' });
                    cookies.set('user', data.result[0], { path: '/' })
                    setMensaje(data["message"]);
                    setShow(true);
                    if(data.result !== false){
                        props.onStepChange(1);
                    }
                }
            } catch (err) {
                if (err.response.status === 404 || err.response.status === 403) {
                    setMensaje(err.response.data.message);
                    setShow(true);
                    window.location.reload();
                }
            }
        }
        setValidated(true);
    };

    function mostrarPassword() {
        var campo = document.getElementById("password_cliente2");
        if (campo.type === "password") {
            campo.type = "text";
            document.getElementById("iconoOcultar").style = "display:none";
            document.getElementById("iconoMostrar").style = "display:block";
        } else {
            campo.type = "password";
            document.getElementById("iconoOcultar").style = "display:block";
            document.getElementById("iconoMostrar").style = "display:none";
        }
    }

    return (
        <Container fluid="md" className="mt-5 mb-5">
            <Row style={{ alignItems: 'center' }}>
                <Col sm={12} md={12} lg={5} className="m-auto m-3 p-3 ">
                    <h1 className="lh-1" ><span className='segundoTitulo d-block display-2'>INICIAR</span> <span className='tercerTitulo d-block display-1 text-dark'>SESIÓN</span></h1>
                </Col>
                <Col style={{ width: "0px", height: "300px", margin: "10px 0px", padding: "1px", backgroundColor: "rgb(169 169 169)" }} sm={1} md={1} className="separadorVertical"></Col>
                <Col sm={12} md={12} lg={6} className="p-0">
                    <Row className="m-0 p-1">
                        <Row>
                            <Col sm={10} className="m-auto">
                                <label>Acceso Usuarios Registrados</label>
                                <br></br>
                                <label>Por favor ingresar los datos de acceso</label>
                                <br></br>
                                <br></br>
                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text className="bg-warning text-white" id="inputGroup-sizing-sm">
                                            <Icon.EnvelopeFill />
                                        </InputGroup.Text>
                                        <Form.Control type="email" name="email" className='iniciarSession' placeholder="Ingresar correo electrónico" required onChange={changeFormulario} />
                                    </InputGroup>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text className="bg-warning text-white" id="inputGroup-sizing-sm">
                                            <Icon.LockFill />
                                        </InputGroup.Text>
                                        <Form.Control type="password" name="password_cliente" id="password_cliente2" className='iniciarSession' placeholder="Ingresar la contraseña" required onChange={changeFormulario} autoComplete="off" />
                                        <Button variant="default" className='vista bg-warning text-white' onClick={mostrarPassword}>
                                            <Icon.EyeFill id="iconoMostrar" style={{ display: "none" }} />
                                            <Icon.EyeSlashFill id="iconoOcultar" />
                                        </Button>
                                    </InputGroup>
                                    <div className="d-grid gap-2">
                                        <Button variant="outline-secondary" type="submit" className='btnIngresar'>Ingresar</Button>
                                        <Link to='/restablecer' className="btn btn-outline-secondary">Recuperar Contraseña</Link>
                                        <center><Link to='/registrarUsuario' className="enlaceRegistro" state={{ page: '/' }}><strong>REGISTRARSE AHORA</strong></Link></center>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </Row>
                </Col>
            </Row>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{mensaje}</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export { IniciarSesion };